@if (showMenu) {
  <msf-summary-wrapper
    [items]="MENU_ITEMS | menuChildren:MenuItemType.WeatherAdministration"
    title="Administration"
  >
    <div title class="flex align-items-center mb-4">
      <h1 class="m-0 text-color">{{ "Administration" | translate }}</h1>
    </div>
    <div right #right class="weather-summary">
      <div class="summary-header">
        <h2 class="summary-title">
          <i class="pi pi-chart-bar mr-2"></i>
          {{ "Summary information" | translate }}
        </h2>
        <button
          pButton
          type="button"
          icon="pi pi-refresh"
          (click)="loadSummaryData()"
          [loading]="loading"
          class="p-button-sm p-button-text"
          [pTooltip]="'Refresh information' | translate"
          tooltipPosition="left"></button>
      </div>
      <div *ngIf="loading" class="loading-container">
        <p-progressSpinner [style]="{ width: '30px', height: '30px' }"></p-progressSpinner>
        <p class="loading-text">{{ "Loading..." | translate }}</p>
      </div>
      <div *ngIf="error" class="error-container">
        <p-message
          severity="error"
          [text]="error"
          [closable]="false"
          [style]="{ 'margin-bottom': '1rem' }"></p-message>
        <button
          pButton
          type="button"
          [label]="'Retry' | translate"
          (click)="loadSummaryData()"
          class="p-button-sm p-button-outlined"></button>
      </div>
      <div *ngIf="summaryData && !loading && !error" class="summary-content">
        <div class="summary-section total-section">
          <div class="section-header">
            <i class="pi pi-globe section-icon"></i>
            <h3 class="section-title">{{ "Total Overview" | translate }}</h3>
          </div>
          <div class="stat-card-large total">
            <div class="stat-icon-large"><i class="pi pi-globe"></i></div>
            <div class="stat-content-large">
              <div class="stat-number-large">{{ summaryData.totalLayers }}</div>
              <div class="stat-label-large">{{ "Total Layers" | translate }}</div>
            </div>
          </div>
        </div>

        <div class="summary-section">
          <div class="section-header">
            <i class="pi pi-chart-line section-icon"></i>
            <h3 class="section-title">{{ "By Data Type" | translate }}</h3>
          </div>
          <div class="stats-grid">
            <div class="stat-card weather">
              <div class="stat-icon"><i class="pi pi-sun"></i></div>
              <div class="stat-content">
                <div class="stat-number">{{ summaryData.weatherLayers }}</div>
                <div class="stat-label">{{ "Weather Layers" | translate }}</div>
              </div>
            </div>
            <div class="stat-card normalized">
              <div class="stat-icon"><i class="pi pi-chart-line"></i></div>
              <div class="stat-content">
                <div class="stat-number">{{ summaryData.normalizedLayers }}</div>
                <div class="stat-label">{{ "Normalized Layers" | translate }}</div>
              </div>
            </div>
            <div class="stat-card deviation">
              <div class="stat-icon"><i class="pi pi-exclamation-triangle"></i></div>
              <div class="stat-content">
                <div class="stat-number">{{ summaryData.deviationLayers }}</div>
                <div class="stat-label">{{ "Deviation Layers" | translate }}</div>
              </div>
            </div>
          </div>
        </div>

        <div class="summary-section">
          <div class="section-header">
            <i class="pi pi-database section-icon"></i>
            <h3 class="section-title">{{ "By Data Source" | translate }}</h3>
          </div>
          <div class="stats-grid">
            <div class="stat-card era">
              <div class="stat-icon"><i class="pi pi-database"></i></div>
              <div class="stat-content">
                <div class="stat-number">{{ summaryData.eraLayers }}</div>
                <div class="stat-label">{{ "ERA Layers" | translate }}</div>
              </div>
            </div>
            <div class="stat-card ibm">
              <div class="stat-icon"><i class="pi pi-server"></i></div>
              <div class="stat-content">
                <div class="stat-number">{{ summaryData.ibmLayers }}</div>
                <div class="stat-label">{{ "IBM Layers" | translate }}</div>
              </div>
            </div>
            <div class="stat-card ugm">
              <div class="stat-icon"><i class="pi pi-cloud"></i></div>
              <div class="stat-content">
                <div class="stat-number">{{ summaryData.ugmLayers }}</div>
                <div class="stat-label">{{ "UGM Layers" | translate }}</div>
              </div>
            </div>
          </div>
        </div>

        <div class="summary-section">
          <div class="section-header">
            <i class="pi pi-cog section-icon"></i>
            <h3 class="section-title">{{ "Background Jobs Status" | translate }}</h3>
          </div>
          <div class="stats-grid">
            <div class="stat-card total">
              <div class="stat-icon"><i class="pi pi-list"></i></div>
              <div class="stat-content">
                <div class="stat-number">{{ summaryData.totalJobs }}</div>
                <div class="stat-label">{{ "Total Jobs" | translate }}</div>
              </div>
            </div>
            <div class="stat-card success">
              <div class="stat-icon"><i class="pi pi-check-circle"></i></div>
              <div class="stat-content">
                <div class="stat-number">{{ summaryData.completedJobs }}</div>
                <div class="stat-label">{{ "Completed Jobs" | translate }}</div>
              </div>
            </div>
            <div class="stat-card error">
              <div class="stat-icon"><i class="pi pi-times-circle"></i></div>
              <div class="stat-content">
                <div class="stat-number">{{ summaryData.failedJobs }}</div>
                <div class="stat-label">{{ "Failed Jobs" | translate }}</div>
              </div>
            </div>
          </div>
        </div>

        <div class="last-update-section">
          <div class="update-info">
            <i class="pi pi-clock"></i>
            <span>{{ "Last layer update" | translate }}
              : {{ summaryData.lastUpdateUtc | date: "dd.MM.yyyy HH:mm" }}</span>
          </div>
          <div class="update-info" *ngIf="summaryData.lastJobExecutionUtc">
            <i class="pi pi-refresh"></i>
            <span>{{ "Last job execution" | translate }}
              : {{ summaryData.lastJobExecutionUtc | date: "dd.MM.yyyy HH:mm" }}</span>
          </div>
        </div>
      </div>
    </div>
  </msf-summary-wrapper>
} @else {
  <router-outlet></router-outlet>
}


